var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalkonChatFeviconIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "F_VOIP_Dark",
    "data-name": "F VOIP Dark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 186.94 128.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #1450ff;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        fill: #002d9e;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 70.03,
    y1: 17.7,
    x2: 169.17,
    y2: 17.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffb300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffa400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9f00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 7344.72,
    x2: 41.87,
    y2: 7344.72,
    gradientTransform: "translate(0 7408.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffac00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m186.94,75.03c0,29.33-23.78,53.11-53.11,53.11-21.22,0-39.54-12.44-48.04-30.45-.76-1.61-1.45-3.26-2.04-4.96.95.84,1.92,1.65,2.92,2.42,8.96,6.93,20.21,11.05,32.42,11.05,29.33,0,53.11-23.78,53.11-53.11,0-6.21-1.07-12.17-3.03-17.7,10.9,9.72,17.76,23.87,17.76,39.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m172.2,53.11c0,29.33-23.78,53.11-53.11,53.11-7.23,0-14.88-1.52-21.84-4.69-4.8-2.19-10.02-5.45-13.5-8.78,16.39-46.09,53.37-31.5,53.37-31.5,0,0-6.62-21.91-34.05-29.19-.1-.03-.2-.05-.31-.07,8.73-6.32,19.46-10.04,31.06-10.04,13.57,0,25.95,5.09,35.34,13.47,1.96,5.54,3.03,11.5,3.03,17.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m169.17,35.4c-9.39-8.38-21.77-13.47-35.34-13.47-11.6,0-22.33,3.72-31.06,10.04-12.5-3.26-22.73-1.99-32.73.78C78.02,13.52,96.98,0,119.09,0s42.79,14.78,50.08,35.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29.3,99.76h26.17c4.34,0,7.85,3.51,7.85,7.85h0c0,4.34-3.51,7.85-7.85,7.85h-26.17c-4.34,0-7.85-3.51-7.85-7.85h0c0-4.34,3.51-7.85,7.85-7.85Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29.27,12.68h26.17c4.34,0,7.85,3.51,7.85,7.85h0c0,4.34-3.51,7.85-7.85,7.85h-26.17c-4.34,0-7.85-3.51-7.85-7.85h0c0-4.34,3.51-7.85,7.85-7.85Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.85,55.94h26.17c4.34,0,7.85,3.51,7.85,7.85h0c0,4.34-3.51,7.85-7.85,7.85H7.85c-4.34,0-7.85-3.51-7.85-7.85h0c0-4.34,3.51-7.85,7.85-7.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonChatFeviconIcon);
export default __webpack_public_path__ + "static/media/falkon-chat-fevicon-icon.aac3469588393f9821081cb4aff03354.svg";
export { ForwardRef as ReactComponent };